function About(){

    return (
        <div className="about-container">
            <h3>General Assembly Student Group Project</h3> 

            <h4>A User-Friendly Event Management Application with Secure User Authentication </h4>
            
            <i>“MyEvents” is a frontend React application that allows users to view, create, delete, and update events. The app features user authentication, ensuring that only authorized users can access and manipulate event information. The user interface is intuitive and easy to navigate, allowing users to quickly and efficiently manage their events. Additionally, the application integrates with a backend service to securely store and retrieve event data. Overall, “MyEvents” is a powerful and user-friendly tool for managing events and keeping track of important dates and deadlines.</i>
            <p>Built By:</p>
            <div className='name-links'>
                <a href='https://github.com/cinduhrz' target='_blank' rel="noreferrer">Cindy Wong/  </a>
                <a href='https://github.com/kayfernander2022' target='_blank' rel="noreferrer">Karen Fernander/</a>
                <a href='https://github.com/SonsOfMagnetism' target='_blank' rel="noreferrer">Rene Santiago/</a>
                <a href='https://github.com/Alex-dev7' target='_blank' rel="noreferrer">Alexei Rusu/</a>
            </div>
            <p>with 💚</p>
        </div>
    )
}

export default About